import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { isLoggedIn } from '../utils/tokenUtils';
import styles from './BoardListPage.module.css';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

function BoardListPage() {
    const [boards, setBoards] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [category, setCategory] = useState('');
    const [keyword, setKeyword] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        loadBoards();
    }, [currentPage, category]);

    const loadBoards = async () => {
        try {
            const params = { page: currentPage, size: 10 };
            if (category) params.category = category;
            if (keyword) params.keyword = keyword;
            const res = await axios.get(`${API_URL}/api/boards`, { params });
            setBoards(res.data.boards);
            setTotalPages(res.data.totalPages);
        } catch (err) {
            console.error(err);
        }
    };

    const handleSearch = () => {
        setKeyword(searchInput);
        setCurrentPage(0);
        loadBoards();
    };

    const handleCategoryChange = (cat) => {
        setCategory(cat);
        setCurrentPage(0);
    };

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>커뮤니티</h2>

            <div className={styles.filterRow}>
                <div className={styles.categories}>
                    {['', 'NOTICE', 'EVENT', 'GENERAL'].map(cat => (
                        <button key={cat}
                            className={`${styles.catBtn} ${category === cat ? styles.active : ''}`}
                            onClick={() => handleCategoryChange(cat)}>
                            {cat === '' ? '전체' : cat === 'NOTICE' ? '공지' : cat === 'EVENT' ? '이벤트' : '자유'}
                        </button>
                    ))}
                </div>
                <div className={styles.searchBox}>
                    <input value={searchInput} onChange={e => setSearchInput(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && handleSearch()}
                        placeholder="검색어 입력" className={styles.searchInput} />
                    <button onClick={handleSearch} className={styles.searchBtn}>검색</button>
                </div>
            </div>

            <table className={styles.table}>
                <thead>
                    <tr>
                        <th>분류</th>
                        <th>제목</th>
                        <th>작성자</th>
                        <th>조회</th>
                        <th>날짜</th>
                    </tr>
                </thead>
                <tbody>
                    {boards.map(board => (
                        <tr key={board.boardId} onClick={() => navigate(`/boards/${board.boardId}`)}
                            className={styles.row}>
                            <td>
                                <span className={`${styles.badge} ${styles[`badge_${board.category}`]}`}>
                                    {board.category === 'NOTICE' ? '공지' : board.category === 'EVENT' ? '이벤트' : '자유'}
                                </span>
                            </td>
                            <td className={styles.titleCell}>
                                {board.isPinned && <span className={styles.pin}>📌</span>}
                                {board.title}
                            </td>
                            <td>{board.userName}</td>
                            <td>{board.viewCount}</td>
                            <td>{new Date(board.createdAt).toLocaleDateString()}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className={styles.pagination}>
                {Array.from({ length: totalPages }, (_, i) => (
                    <button key={i} onClick={() => setCurrentPage(i)}
                        className={`${styles.pageBtn} ${i === currentPage ? styles.activePage : ''}`}>
                        {i + 1}
                    </button>
                ))}
            </div>

            {isLoggedIn() && (
                <div className={styles.writeBtn}>
                    <button onClick={() => navigate('/boards/write')} className={styles.writeBtnInner}>
                        글쓰기
                    </button>
                </div>
            )}
        </div>
    );
}

export default BoardListPage;